import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import dedupe from 'portal-modules/common/utils/dedupe'

// action types
export const REQUEST_COMPANY_LINKS = 'rp/companyLinks/REQUEST_COMPANY_LINKS'
export const RECEIVE_COMPANY_LINKS = 'rp/companyLinks/RECEIVE_COMPANY_LINKS'
export const COMPANY_LINKS_API_CALLED =
  'rp/companyLinks/COMPANY_LINKS_API_CALLED'
export const CLEAR_COMPANY_LINKS = 'rp/companyLinks/CLEAR_COMPANY_LINKS'

// reducer
export default (state = [], { payload, type }) => {
  switch (type) {
    case RECEIVE_COMPANY_LINKS:
      return { comapny_links: dedupe([...state, ...payload], 'id') }
    case COMPANY_LINKS_API_CALLED:
      return { ...state, isRequested: payload.isRequested }
    case LOGOUT:
    case CLEAR_COMPANY_LINKS:
      return []
    default:
      return state
  }
}

// action creators
export const requestCompanyLinks = () => ({
  type: REQUEST_COMPANY_LINKS,
})

export const receiveCompanyLinks = payload => ({
  type: RECEIVE_COMPANY_LINKS,
  payload,
})

// sagas
export function* fetchCompanyLinks() {
  const { links } = yield call(Api.getCompanyLinks)
  if (links) {
    yield put(receiveCompanyLinks(links))
  }
  yield put({ type: COMPANY_LINKS_API_CALLED, payload: { isRequested: true } })
}

function* watchRequestCompanyLinks() {
  yield takeLatest(
    REQUEST_COMPANY_LINKS,
    createRequestSaga(fetchCompanyLinks, {
      key: 'companyLinks',
      message: __('Looking up company links'),
    }),
  )
}

export const sagas = [watchRequestCompanyLinks]
